import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { MappingtypeComponent } from '../../mappingtype/mappingtype.component';
import { CommonService } from 'src/app/shared/services/common.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { ManagemdlscriptComponent } from '../managemdlscript.component';

export interface managemdlscriptpopup {
  edata: any;
}

@Component({
    selector: 'app-managemdlscriptpopup',
    templateUrl: './managemdlscriptpopup.component.html',
    styleUrls: ['./managemdlscriptpopup.component.scss'],
    standalone: false
})
export class ManagemdlscriptpopupComponent implements OnInit {
  FormValid: FormGroup;
  formValidCheckbox: UntypedFormGroup;
  isCheckboxSelected = false;
  isexecutable = false;

  showCreateAnother = true;
  buttonName
  backgroundColorButton
  validation_messages: any;
  JsuiteCategoryData: any = []
  selectedCategory: any
  componentTypeData: any = []

  idColumn
  updatedData;



  mdlscript = {
    'managemdlscriptId': '', 'propertycategory': '', 'propertyname': '', 'component_type': '', 'isexecutable': this.isexecutable,'executionorder':'', 'createmdltemplate': '', 'updatemdltemplate': '', 'tenantId': ''
  }
  propertyData: any;


  constructor(private localstorage: LocalStorageSettingsService, private validation: validationmethod, public dialogRef: MatDialogRef<ManagemdlscriptComponent>, private commonservice: CommonService, private spinner: NgxUiLoaderService, private snackbar: MatSnackBar, @Inject(MAT_DIALOG_DATA) public data: managemdlscriptpopup, private errormessage: ErrorMessages) {
    this.validation_messages = this.errormessage.mdlscript;

  }

  ngOnInit(): void {
    this.buttonName = 'Save'

    this.backgroundColorButton = this.localstorage.getSettings('ColorA');
    this.formvalidations();
    this.formValidationsCheckbox();

    this.getJsuiteProperty();
    this.retrieveComponentType();
    const dnsId = this.localstorage.getSettings("dnsName")

    console.log(this.data.edata)
    this.updatedData = this.data.edata
    if (this.updatedData.managemdlscriptId != undefined) {
      this.buttonName = 'Update'
      this.showCreateAnother = false;
      console.log("property category", this.updatedData.propertycategory)
      this.mdlscript.managemdlscriptId = this.updatedData.managemdlscriptId
      this.mdlscript.propertycategory = this.updatedData.propertycategory
      this.mdlscript.propertyname = this.updatedData.propertyname
      this.mdlscript.component_type = this.updatedData.component_type
      this.mdlscript.createmdltemplate = this.updatedData.createmdltemplate
      this.mdlscript.updatemdltemplate = this.updatedData.updatemdltemplate
      this.mdlscript.isexecutable = this.updatedData.isexecutable
      this.mdlscript.executionorder=this.updatedData.executionorder
      if (this.isexecutable == true)
        this.mdlscript.isexecutable = true


      this.commonservice
        .getjsuitePropertyByCategory(this.updatedData.propertycategory)
        .subscribe((res: any) => {
          this.propertyData = res;

          console.log('property category:', this.updatedData.propertycategory);
          console.log('propertyData:', this.propertyData);
          console.log('propertyname:', this.updatedData.propertyname);

          if (this.updatedData.propertyname && this.propertyData?.length > 0) {
            const selectedIds = this.updatedData.propertyname
              .replace(/\[|\]/g, '')
              .split(',')
              .map(id => Number(id.trim()))
              .filter(id => !isNaN(id));
            console.log(this.updatedData.propertyname)
            this.FormValid.get('propertyname')?.setValue(this.updatedData.propertyname);
          }
        });
    }
    console.log(this.data)




  }
  formValidationsCheckbox() {
    this.formValidCheckbox = new UntypedFormGroup({
      isCheckboxSelected: new UntypedFormControl(false),
      isexecutable: new UntypedFormControl(false)
    });
  }
  saveMethod() {
    if (!this.FormValid.valid) {
      this.FormValid.markAllAsTouched();

      this.snackbar.open("All mandatory fields to be filled", "ok", { duration: 3000 });
      return
    }

    console.log('Saving Data:', this.FormValid.value.mappingtypename);
    var dnsid = localStorage.getItem('dnsName');
    if (this.buttonName == 'Update') {
      this.idColumn = this.mdlscript.managemdlscriptId;
    } else {
      this.idColumn = 0;
    }

    const requestData = {
      propertycategory: this.mdlscript.propertycategory,
      tenantid: dnsid,
      managemdlscriptId: this.idColumn,
      propertyname: this.mdlscript.propertyname,
      component_type: this.mdlscript.component_type,
      isexecutable: this.mdlscript.isexecutable,
      createmdltemplate: this.mdlscript.createmdltemplate,
      updatemdltemplate: this.mdlscript.updatemdltemplate,
      executionorder:this.mdlscript.executionorder

    };
    this.spinner.start();
    this.commonservice.saveManageMdlScript(requestData).subscribe({
      next: (response) => {
        if (response.error === true) {
          this.snackbar.open(response.statusMessage, 'OK', { duration: 3000 });
          this.spinner.stop();
          return
        }
        console.log('edit successful', response);
        console.log(response.data)
        this.updatedData = null;
        this.snackbar.open(response.statusMessage, 'OK', { duration: 3000 });
        if (this.isCheckboxSelected && this.buttonName === 'Save') {
          this.FormValid.reset();
          this.mdlscript.propertycategory = '',
            this.mdlscript.propertyname = '',
            this.mdlscript.isexecutable = this.isexecutable,
            this.mdlscript.component_type = '',
            this.mdlscript.createmdltemplate = '',
            this.mdlscript.updatemdltemplate = '',
            this.mdlscript.executionorder=''
          this.isCheckboxSelected = false

          this.buttonName = 'Save';
        } else {
          this.dialogRef.close(response.data);
        }
      },
      error: (error: any) => {
        console.error('retrieve failed', error);
        this.spinner.stop();
      },
      complete: () => {
        console.log('retrieve  completed');
        this.updatedData = null
        this.spinner.stop();
      }
    });
  }
  cancel() {
    this.dialogRef.close();
  }
  formvalidations() {
    this.FormValid = new FormGroup({
      'propertycategory': new FormControl('', [Validators.required]),
      'propertyname': new FormControl('', [Validators.required]),
      'component_type': new FormControl('', [Validators.required]),
      'isexecutable': new UntypedFormControl(false),
      'createmdltemplate': new FormControl('', [Validators.required]),
      'updatemdltemplate': new FormControl('', [Validators.required]),
      'executionorder': new FormControl('', [Validators.required])
    })
  }

  getJsuiteProperty() {
    this.spinner.start();
    this.commonservice
      .getjsuiteCategory("Jsuite Property Category")
      .subscribe({
        next: (res) => {
          console.log(res)
          this.JsuiteCategoryData = res;
          console.log(this.JsuiteCategoryData)
          this.spinner.stop();
        },
        error: (err) => {
          console.error(err);
          this.spinner.stop();
        }
      });
  }

  retrieveComponentType() {
    this.spinner.start();
    const dnsName = this.localstorage.getSettings("vaultDnsname")

    this.commonservice
      .getComponentType(dnsName)
      .subscribe({
        next: (res) => {
          console.log(res)
          this.componentTypeData = res;
          console.log(this.componentTypeData)
          this.spinner.stop();
        },
        error: (err) => {
          console.error(err);
          this.spinner.stop();
        }
      });
  }
 


  onPropertyCategoryChange(event) {
    this.spinner.start();
    console.log(event);
    const selected = event.value;
    console.log("Selected Property Category:", selected);
    console.log(event.value.objectGroupId)
    this.mdlscript.propertycategory = event.value
    console.log(this.mdlscript.propertycategory);

    let propertycategory = this.JsuiteCategoryData.filter(item => item == event.value)[0];
    this.mdlscript.propertycategory = propertycategory;
    console.log(propertycategory);

    const dnsId = this.localstorage.getSettings("dnsName")
    this.commonservice.getjsuitePropertyByCategory(selected).subscribe((res: any) => {
      console.log(res);
      if (res.error == true) {
        this.snackbar.open(res.statusMessage, "OK", {
          duration: 5000,
        });
      } else {
        console.log(res);
        this.propertyData = res.filter((obj: any) => obj.status === 'Yes')
        console.log(this.propertyData)
      }
      this.spinner.stop();
    })
  }
  onpropertyChange(event: any) {
    console.log('Selected  property:', event.value);
    this.mdlscript.propertyname = event.value;
  }
  onComponentTypeChange(event: any) {
    console.log('Selected  component type:', event.value);
    this.mdlscript.component_type = event.value;
  }
  updateCheckbox(event: any) {
    console.log('Selected isexecutable :', event.checked);
    this.mdlscript.isexecutable = event.checked;
    this.isexecutable = event.checked;
  }

}
